import { defineStore } from 'pinia';
import to from 'await-to-js';
import { apis } from '/@/apis';
import { AvailableMagicBeanInfoRes } from '@lingtu//apis/entities';

const { transactions } = apis;
interface ICommerceStoreState {
  lingdouInfo: AvailableMagicBeanInfoRes | null;
  fetchingLingdouInfo: boolean;
}
export const useCommerceStore = defineStore({
  id: 'commerce',
  state: (): ICommerceStoreState => ({
    lingdouInfo: null,
    fetchingLingdouInfo: false,
  }),
  getters: {
    // 是否是会员
    isVip(): boolean {
      return !!this.lingdouInfo?.memberShip?.member;
    },

    // 剩余灵豆数量
    lingdouNum(): number {
      return this.lingdouInfo?.total || 0;
    },

    // 席位上限
    seatUpperLimit(): number {
      return this.lingdouInfo?.memberShip?.seat || 0;
    },
    // 是否拥有智绘画布权限
    hasCanvasPermission(): boolean {
      return !!this.lingdouInfo?.memberShip?.canvas;
    },

    // 是否只能下载水印图片
    onlyWatermarkImg(): boolean {
      return !!!this.lingdouInfo?.memberShip?.noWaterMarkDownload;
    },
  },
  actions: {
    // 获取灵豆信息，如果已经存在信息不会重新获取
    async getLingdouInfo() {
      if (this.lingdouInfo) {
        return this.lingdouInfo;
      }
      const lingdouInfo = await this.updateLingdouInfo();

      return lingdouInfo;
    },

    // 重新获取灵豆信息
    async updateLingdouInfo() {
      if (!this.fetchingLingdouInfo) {
        this.fetchingLingdouInfo = true;
        const [_, res] = await to(transactions.availableMagicBeanInfo());
        this.lingdouInfo = res || null;
        this.fetchingLingdouInfo = false;
        return this.lingdouInfo;
      } else {
        return await new Promise((resolve) => {
          this.$subscribe(() => {
            if (this.lingdouInfo) {
              resolve(this.lingdouInfo);
            }
          });
        });
      }
    },
  },
});

export function useCommerceStoreWithOut() {
  return useCommerceStore();
}
